(ns app.transit
  (:require [cognitect.transit :as transit]))

(def encoder (transit/writer :json))
(def decoder (transit/reader :json))

(defn encode
  "Transit-encodes `data` and returns a string."
  [data]
  (transit/write encoder data))

(defn decode
  "Transit-decodes string `s` and returns a value."
  [s]
  (transit/read decoder s))
